var _rect, _rect2, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrypto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 36,
    viewBox: "0 0 48 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47.9966,
    height: 36,
    rx: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 46.9966,
    height: 35,
    rx: 7.5,
    stroke: "#040517",
    strokeOpacity: 0.08
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_591_2776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 28C23.5228 28 28 23.5228 28 18C28 12.4772 23.5228 8 18 8C12.4772 8 8 12.4772 8 18C8 23.5228 12.4772 28 18 28Z",
    fill: "#627EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9077 10.5454V16.0567L22.5422 18.1382L17.9077 10.5454Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9078 10.5454L13.2727 18.1382L17.9078 16.0567V10.5454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9077 21.7097V25.4545L22.5453 19.0057L17.9077 21.7097Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9078 25.4545V21.7091L13.2727 19.0057L17.9078 25.4545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9077 20.8429L22.5422 18.1382L17.9077 16.058V20.8429Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2727 18.1382L17.9078 20.8429V16.058L13.2727 18.1382Z",
    fill: "white",
    fillOpacity: 0.602
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_591_2776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 28C35.5228 28 40 23.5228 40 18C40 12.4772 35.5228 8 30 8C24.4772 8 20 12.4772 20 18C20 23.5228 24.4772 28 30 28Z",
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4931 16.7625C34.6894 15.4525 33.6913 14.7481 32.3275 14.2781L32.77 12.5031L31.69 12.2344L31.2588 13.9625C30.975 13.8912 30.6838 13.825 30.3931 13.7587L30.8275 12.0194L29.7475 11.75L29.305 13.5244C29.07 13.4706 28.8388 13.4181 28.615 13.3619L28.6163 13.3562L27.1263 12.9844L26.8388 14.1381C26.8388 14.1381 27.6406 14.3219 27.6238 14.3331C28.0613 14.4425 28.14 14.7319 28.1269 14.9619L27.6231 16.9837C27.6531 16.9912 27.6919 17.0025 27.7356 17.0194L27.6213 16.9913L26.915 19.8237C26.8613 19.9562 26.7256 20.1556 26.4194 20.08C26.4306 20.0956 25.6344 19.8844 25.6344 19.8844L25.0981 21.1206L26.5044 21.4713C26.7656 21.5369 27.0219 21.6056 27.2738 21.67L26.8269 23.465L27.9063 23.7337L28.3488 21.9587C28.6438 22.0381 28.93 22.1119 29.21 22.1819L28.7688 23.9494L29.8488 24.2181L30.2956 22.4269C32.1381 22.7756 33.5231 22.635 34.1063 20.9688C34.5763 19.6275 34.0831 18.8531 33.1138 18.3488C33.82 18.1863 34.3513 17.7219 34.4931 16.7625ZM32.0244 20.2238C31.6913 21.5656 29.4319 20.84 28.6994 20.6581L29.2931 18.28C30.0256 18.4631 32.3738 18.825 32.0244 20.2238ZM32.3588 16.7431C32.0544 17.9638 30.1744 17.3431 29.565 17.1913L30.1025 15.035C30.7119 15.1869 32.6763 15.47 32.3588 16.7431Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_591_2776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_591_2776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(20 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrypto);
export default __webpack_public_path__ + "static/media/crypto.588273b35f90e641226511a63fa686e7.svg";
export { ForwardRef as ReactComponent };